import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Leyendas legales por tecnología: el texto lo define el área legal, no editarlo sin su visto bueno.
const LEYENDA_FIBRA = 'El servicio de internet se presta bajo tecnología de fibra óptica y es para uso residencial (paquetes: básico +, premium +, Gold + o Gamer+) o empresarial (paquete empresarial +), es decir, debe utilizarse el servicio conforme al consumo de un sólo hogar o empresa/negocio/comercio, sin fines de lucro. Las velocidades de carga y descarga ofertadas varían debido a que el servicio de internet es asimétrico.';
const LEYENDA_INALAMBRICO = 'El servicio de internet se presta bajo tecnología inalámbrica en la que se transmiten datos a través de microondas -por antena- y es para uso residencial, es decir, debe utilizarse el servicio conforme al consumo de un sólo hogar sin fines de lucro. Las velocidades de carga y descarga ofertadas varían debido a que el servicio de internet es asimétrico.';
const LEYENDA_SIMETRICO = 'Si deseas que tu paquete de fibra óptica tenga velocidad de subida y bajada (carga y descarga) ofertada simétrica, únicamente paga $50.00 adicionales al costo de la mensualidad de tu paquete ¡Solicita el cambio!';

// Datos de los planes. `folio` es el registro de la tarifa ante el IFT; no cambiarlo sin el formato simplificado.
const PLANES = {
    fibra: {
        tecnologia: 'Fibra óptica',
        leyendas: [LEYENDA_FIBRA, LEYENDA_SIMETRICO],
        planes: [
            { nombre: 'Básico+', precio: 300, bajada: 100, subida: 25, folio: '1347531', imagen: 'fibra-basico' },
            { nombre: 'Premium+', precio: 400, bajada: 200, subida: 50, folio: '1347531', imagen: 'fibra-premium', popular: true, badge: 'Popular' },
            { nombre: 'Gold+', precio: 500, bajada: 300, subida: 100, folio: '1347543', imagen: 'fibra-gold' },
            { nombre: 'Gamer+', precio: 700, bajada: 600, subida: 200, folio: '1347545', imagen: 'fibra-gamer' },
        ],
    },
    wireless: {
        tecnologia: 'Internet inalámbrico',
        leyendas: [LEYENDA_INALAMBRICO],
        planes: [
            { nombre: 'Básico', precio: 300, bajada: 3, subida: 1, folio: '1345218', imagen: 'wireless-basico' },
            { nombre: 'Premium', precio: 400, bajada: 8, subida: 1.2, folio: '1345223', imagen: 'wireless-premium', popular: true, badge: 'Popular' },
            { nombre: 'Gold', precio: 500, bajada: 10, subida: 2, folio: '1345224', imagen: 'wireless-gold' },
            { nombre: 'Gamer', precio: 700, bajada: 15, subida: 2.5, folio: '1345225', imagen: 'wireless-gamer' },
        ],
    },
    negocios: {
        tecnologia: 'Fibra óptica',
        leyendas: [LEYENDA_FIBRA, LEYENDA_SIMETRICO],
        planes: [
            { nombre: 'Empresarial+', precio: 1000, bajada: 1000, subida: 500, folio: '1347559', imagen: 'fibra-empresarial', badge: 'Negocios' },
        ],
    },
};

const TABS = [
    { id: 'fibra', texto: 'Fibra óptica' },
    { id: 'wireless', texto: 'Inalámbrico' },
    { id: 'negocios', texto: 'Negocios' },
];

const WHATSAPP_NEGOCIOS = 'https://wa.me/5217712438160?text=' + encodeURIComponent('Hola, me interesa internet para mi negocio.');

// Acompaña a la tarjeta Empresarial+ en la pestaña Negocios
const PanelNegocios = () => (
    <aside className="planesItmex-panel">
        <span className="planesItmex-eyebrow">A la medida</span>
        <h3 className="planesItmex-panel-titulo">¿Tu negocio necesita algo diferente?</h3>
        <p>Cuéntanos cómo trabajas y te ayudamos a elegir la conexión para tu oficina, local o sucursales.</p>
        <ul>
            <li><i className="fas fa-users"></i>Cuántas personas y equipos se conectan</li>
            <li><i className="fas fa-store"></i>Cuántas sucursales o ubicaciones tienes</li>
            <li><i className="fas fa-clock"></i>En qué horarios usas más el internet</li>
        </ul>
        <div className="planesItmex-panel-acciones">
            <Link className="heroItmex-cta planesItmex-panel-cta" to="/contacto">
                Hablar con ventas
                <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
            </Link>
            <a className="planesItmex-panel-whatsapp" href={WHATSAPP_NEGOCIOS} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"></i> WhatsApp
            </a>
        </div>
    </aside>
);

const Velocidad = ({ plan }) => (
    <div className="planItmex-velocidad">
        <span className="planItmex-velocidad-num">{plan.bajada}</span>
        <span className="planItmex-velocidad-unidad">Mb</span>
        <span className="planItmex-velocidad-label">de descarga</span>
    </div>
);

const Detalles = ({ plan, tecnologia }) => (
    <ul className="planItmex-detalles">
        <li><i className="fas fa-arrow-up"></i>{plan.subida} Mb de subida</li>
        <li><i className="fas fa-wifi"></i>{tecnologia}</li>
        <li><i className="fas fa-headset"></i>Soporte técnico</li>
        <li className="planItmex-folio"># de inscripción {plan.folio}</li>
    </ul>
);

const Precio = ({ plan }) => (
    <div className="planItmex-precio">
        <span className="planItmex-precio-num">${plan.precio}<sup>*</sup></span>
        <span className="planItmex-precio-periodo">/ mes</span>
    </div>
);

const BotonContratar = ({ plan }) => (
    <Link className="planItmex-cta" to="/contacto" aria-label={`Contratar ${plan.nombre}`}>
        Contratar
        <span className="planItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
    </Link>
);

const PlanCard = ({ plan, tecnologia }) => (
    <article className={'planItmex' + (plan.popular ? ' planItmex--popular' : '')}>
        <div className="planItmex-figura">
            <img src={`/assets/img/planes/${plan.imagen}.jpg`} alt="" loading="lazy" />
        </div>
        <div className="planItmex-cuerpo">
            <div className="planItmex-encabezado">
                <h3 className="planItmex-nombre">{plan.nombre}</h3>
                {plan.badge && <span className="planItmex-badge">{plan.badge}</span>}
            </div>
            <Velocidad plan={plan} />
            <Precio plan={plan} />
            <Detalles plan={plan} tecnologia={tecnologia} />
            <BotonContratar plan={plan} />
        </div>
    </article>
);


const Planes = () => {
    const [tipo, setTipo] = useState('fibra');
    const grupo = PLANES[tipo];

    return (
        <section className="planesItmex" id="planesInternet">
            <div className="planesItmex-header">
                <span className="planesItmex-eyebrow">Planes</span>
                <h2 className="tituloItmex">Internet para tu hogar<br />y tu negocio</h2>
                <p className="planesItmex-subtitulo">Fibra óptica o inalámbrico, según la cobertura de tu comunidad.</p>

                <div className="planesItmex-toggle" role="tablist" aria-label="Tipo de plan"
                    style={{ '--tabs': TABS.length, '--indice': TABS.findIndex(t => t.id === tipo) }}>
                    <span className="planesItmex-toggle-indicador"></span>
                    {TABS.map(tab => (
                        <button key={tab.id} type="button" role="tab" aria-selected={tipo === tab.id} onClick={() => setTipo(tab.id)}>
                            {tab.texto}
                        </button>
                    ))}
                </div>
            </div>

            {/* En escritorio es una cuadrícula; en tablet/móvil, un carrusel deslizable (ver index.css) */}
            {tipo === 'negocios' ? (
                <div className="planesItmex-negocios" key={tipo}>
                    {grupo.planes.map(plan => <PlanCard key={plan.nombre} plan={plan} tecnologia={grupo.tecnologia} />)}
                    <PanelNegocios />
                </div>
            ) : (
                <div className="planesItmex-grid" key={tipo} style={{ '--columnas': grupo.planes.length }}>
                    {grupo.planes.map(plan => <PlanCard key={plan.nombre} plan={plan} tecnologia={grupo.tecnologia} />)}
                </div>
            )}

            <div className="planesItmex-leyendas" key={'leyendas-' + tipo}>
                <p className="planesItmex-leyenda-precios">*Los costos están señalados en moneda nacional e incluyen impuestos.</p>
                {grupo.leyendas.map(leyenda => <p key={leyenda}>{leyenda}</p>)}
            </div>

            <div className="planesItmex-notas">
                <p><i className="fas fa-map-marker-alt"></i>Revisa nuestra cobertura de red fibra óptica y wireless <Link to="/cobertura">aquí</Link>.</p>
                <p><i className="far fa-question-circle"></i>Puedes revisar nuestro apartado de preguntas frecuentes <Link to="/internet/faq">aquí</Link>.</p>
                <p><i className="fas fa-balance-scale"></i>Para más información respecto a las tarifas puedes consultar el visor de tarifas de la Comisión Reguladora de Telecomunicaciones, en el siguiente enlace: <a href="https://tarifas.ift.org.mx/ift_visor/" target="_blank" rel="noopener noreferrer">https://tarifas.ift.org.mx/ift_visor/</a>.</p>
            </div>
        </section>
    );
};

export default Planes;
